// Reducer for the details of a topic.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultTopicSegmentsState = {
  ...DefaultState
}

export const topicSegments = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultTopicSegmentsState,
  actionRequest: ActionTypes.REQUEST_TOPIC_PLAN_SEGMENTS,
  actionFailure: ActionTypes.REQUEST_TOPIC_PLAN_SEGMENTS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_TOPIC_PLAN_SEGMENTS,
  actionInvalidate: ActionTypes.INVALIDATE_TOPIC_PLAN_SEGMENTS
})
